"use strict";

require("../../style/index.css");

require("./index.css");

require("../../tooltip/style/css");